<h2 mat-dialog-title>Change Email</h2>

<mat-dialog-content>
  <div class="p-4">
    <form>
      <div class="mce-form-section space-y-4">
        <p>
          Changing your email address will remove access from your old email.
          You will need to sign in again with the new email address.
        </p>

        <mat-form-field class="w-full">
          <mat-label>New email</mat-label>
          <input matInput
                 [formField]="form.newEmail"
                 placeholder="Enter your new email address" />

          @for (error of form.newEmail().errors(); track error.kind ) {
          <mat-error>
            {{ error.message }}
          </mat-error>
          }
        </mat-form-field>

        <mat-checkbox [formField]="form.acknowledged"
                      required>
          I understand that my old email address will lose access to this account.
        </mat-checkbox>

        @if (viewState().otpSending) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

        @if (viewState().showOtpError) {
        <mce-info-message [type]="'error'">
          Unable to email a one time password. Please try again.
        </mce-info-message>
        }

        @if (viewState().showOtpInput) {
        <mce-info-message [type]="'information'">
          A one time password has been emailed to you. Enter it below to continue.
        </mce-info-message>

        <mat-form-field class="w-full">
          <mat-label>One time password</mat-label>
          <input matInput
                 [formField]="form.otp"
                 placeholder="Enter the one time password" />

          @for (error of form.otp().errors(); track error.kind ) {
          <mat-error>
            {{ error.message }}
          </mat-error>
          }
        </mat-form-field>
        }
      </div>
    </form>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="w-full">
    <mce-save-cancel [config]="saveCancelConfig()"
                     (action)="onSaveCancelAction($event)">
      <button matButton="elevated"
              type="button"
              [disabled]="!viewState().enableChange"
              (click)="onChangeEmailClick()">
        <mat-icon>alternate_email</mat-icon>Change Email
      </button>
    </mce-save-cancel>
  </div>
</div>
